import React, { Component } from 'react';
import './HomeView.css';
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
import 'react-autocomplete-input/dist/bundle.css';
import InfoIcon from "./infoicon";
import Select from "react-select";
import { withStyles } from "@material-ui/core/styles";
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import Nextbutton from "../components/Nextbutton";
import moment from 'moment-timezone';
import { compressImage, uploadPhoto, retryPendingUploads } from '../../photoUpload';

const styles = theme => ({
  root: {
    padding: "none"
  },
  textField: {
    width: "11rem",
    height: "2.75rem",
    background: "#ffffff",
    marginTop: "unset",
    marginLeft: "0.7rem",
    border: "1.5px solid #e8e9ed",
    borderRadius: "0.5rem",
    transition: "border-color 150ms ease, box-shadow 150ms ease",
    "&:hover": {
      borderColor: "#8e8e9a",
    },
    "&:focus-within": {
      borderColor: "#4b1f7d",
      boxShadow: "0 0 0 3px rgba(75, 31, 125, 0.1)",
    },
  },
  dateTestfield: {
    border: "1.5px solid #e8e9ed",
    width: "100%",
    height: "2.75rem",
    textAlign: "center",
    backgroundColor: "#ffffff",
    borderRadius: "0.5rem",
    boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
    boxSizing: 'border-box',
    display: "flex",
    paddingLeft: "1rem",
    position: "relative",
    zIndex: 10,
    transition: "border-color 150ms ease, box-shadow 150ms ease",
    "&:hover": {
      borderColor: "#8e8e9a",
    },
    "&:focus-within": {
      borderColor: "#4b1f7d",
      boxShadow: "0 0 0 3px rgba(75, 31, 125, 0.1)",
    },
  }
});



const sentiment = [
  { value: 'Excellent', label: 'Excellent' },
  { value: 'Good', label: 'Good' },
  { value: 'Average', label: 'Average' },
  { value: 'Poor', label: 'Poor' },
];


const zipcodess = [
  { value: "Aldrich", label: 'Aldrich'},
  { value: "Butte", label: 'Butte'},
  { value: "Butte/Padre", label: 'Butte/Padre' },
  { value: "Carmel", label: 'Carmel' },
  { value: "Fritz", label: 'Fritz' },
  { value: "Independence", label: 'Independence' },
  { value: "Monterey", label: 'Monterey' },
  { value: "Nonpareil", label: 'Nonpareil' },
  { value: "Padre", label: 'Padre' },
  { value: "Shasta", label: 'Shasta' },
  { value: "Sonora", label: 'Sonora' },
  { value: "Wood Colony", label: 'Wood Colony' },
  { value: "California", label: 'California' }
];

const almondVariety = [
  { value: "Unknown", label: 'Unknown'},
  { value: "Aldrich", label: 'Aldrich' },
  { value: "Butte", label: 'Butte' },
  { value: "Butte/Padre", label: 'Butte/Padre' },
  { value: "Carmel", label: 'Carmel' },
  { value: "Fritz", label: 'Fritz' },
  { value: "Independence", label: 'Independence' },
  { value: "Monterey", label: 'Monterey' },
  { value: "Nonpareil", label: 'Nonpareil' },
  { value: "Padre", label: 'Padre' },
  { value: "Shasta", label: 'Shasta' },
  { value: "Sonora", label: 'Sonora' },
  { value: "Wood Colony", label: 'Wood Colony' },
  { value: "California", label: 'California' }
];


const bloomStage = [
  { value: 'Green tip', label: 'Green Tip' },
  { value: 'Pink bud', label: 'Pink Bud' },
  { value: 'Popcorn', label: 'Popcorn' },
  { value: 'Early Bloom', label: 'Early Bloom' },
  { value: 'Full Bloom', label: 'Full Bloom' },
  { value: 'Petal fall', label: 'Petal Fall' }
];

const selectCustomStyles = {
  container: (provided) => ({
    ...provided,
    width: "100%",
  }),
  menu: (provided, state) => ({
    ...provided,
    background: "#ffffff",
    borderRadius: "0.5rem",
    boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
    border: "1px solid #e8e9ed",
    marginTop: "4px",
    overflow: "hidden",
    zIndex: 100,
  }),
  menuList: (provided, state) => ({
    ...provided,
    padding: "4px",
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? "#4b1f7d" : state.isFocused ? "#f8f9fc" : "#ffffff",
    color: state.isSelected ? "#ffffff" : "#1a1a2e",
    padding: "12px 14px",
    borderRadius: "0.375rem",
    cursor: "pointer",
    fontSize: "16px",
    textAlign: "center",
    transition: "background-color 150ms ease",
    "&:active": {
      backgroundColor: state.isSelected ? "#4b1f7d" : "#f0f1f5",
    },
  }),
  control: (provided, { selectProps, isFocused }) => ({
    ...provided,
    background: "#ffffff",
    display: "flex",
    width: "100%",
    minHeight: "2.75rem",
    height: "2.75rem",
    textAlign: 'center',
    paddingLeft: "0.5rem",
    cursor: "pointer",
    fontFamily: "Sofia Pro",
    fontSize: "16px",
    border: selectProps.hasError
      ? "1.5px solid #ef4444"
      : isFocused
        ? "1.5px solid #4b1f7d"
        : "1.5px solid #e8e9ed",
    borderRadius: "0.5rem",
    boxShadow: isFocused ? "0 0 0 3px rgba(75, 31, 125, 0.1)" : "0 1px 2px rgba(0, 0, 0, 0.05)",
    transition: "all 150ms ease",
    "&:hover": {
      borderColor: selectProps.hasError ? "#ef4444" : "#8e8e9a",
    },
  }),
  input: (provided) => ({
    ...provided,
    fontSize: "16px",
  }),
  singleValue: (provided, state) => ({
    ...provided,
    color: "#1a1a2e",
    fontSize: "16px",
    textAlign: "center",
    width: "100%",
  }),
  placeholder: (provided, state) => ({
    ...provided,
    color: "#8e8e9a",
    fontSize: "16px",
    textAlign: "center",
    width: "100%",
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    color: "#8e8e9a",
    padding: "8px",
    transition: "transform 150ms ease",
    transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : "rotate(0deg)",
    "&:hover": {
      color: "#4b1f7d",
    },
  }),
};

const filterOptions = createFilterOptions({
  matchFrom: 'start',
  stringify: option => option,
});

const formFields = {
  email: { required: false },
  date: { required: true },
  location: { required: true },
  almond_variety: { required: true },
  bloom_stage: { required: true },
  bloom_sent: { required: true },
  bee_flight: { required: true }
};

const getToday = function () {
  var d = new Date(),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2)
    month = '0' + month;
  if (day.length < 2)
    day = '0' + day;

  return [month, day, year].join('/');
}

const defaultDate = moment().tz("America/Los_Angeles").format("MM/DD/YYYY")
const defaultFormatDate = moment().tz("America/Los_Angeles").format("YYYY-MM-DD")

class HomeView extends Component {
  constructor(props) {
    super(props);

    // init state for form fields
    let initStateObj = {};
    for (var key in formFields) {
      initStateObj[key] = null;
    }

    // add custom state for error
    initStateObj['date'] = defaultFormatDate;
    initStateObj['inputValue'] = defaultDate;
    initStateObj['error'] = null;
    initStateObj['vote_submitted'] = false;
    initStateObj['show_error'] = false;
    initStateObj['zipcodes'] = [];
    initStateObj['almond_variety'] = null;
    initStateObj['bloom_stage'] = null;
    initStateObj['bloom_sent'] = null;
    initStateObj['verification'] = this.props.email ? 'verified' : 'failed';
    initStateObj['votes'] = null;
    initStateObj['iframe_url'] = '/map.html?showdata=0';
    initStateObj['existing_email'] = this.props.email;
    initStateObj['email'] = this.props.email;
    initStateObj['photo_file'] = null;
    initStateObj['photo_preview'] = null;
    initStateObj['photo_uploading'] = false;
    initStateObj['photo_caption'] = '';
    initStateObj['photo_message'] = '';



    // set and init state
    this.state = initStateObj;

    this.handleChange = this.handleChange.bind(this);
    this.handleSpecialChange = this.handleSpecialChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    retryPendingUploads();

    fetch('/api/get_zipcodes', {
      method: 'GET'
    })
      .then(response => {
        if (!response.ok) {

        } else {
          response.json().then(data => {
            this.setState({ zipcodes: data.zipcodes })
          });
        }
      });
  }

  // hanlde selection change
  handleChange(event) {
    const value = event.target.value;
    this.setState({
      [event.target.name]: value
    });
  }

  // handle selection change for special inputs
  handleSpecialChange(name, a, value) {
    this.setState({
      [name]: value
    });
  }
  //handle date change
  handleDateChange = (date, value) => {
    this.setState({
      date: moment(date).format("YYYY-MM-DD"),
      inputValue: value
    })
  }
  handleSelectedValue = (e, name) => {
    this.setState({
      [name]: e.value
    })
  }

  handlePhotoChange = (event) => {
    var file = event.target.files[0];
    if (!file) return;

    if (file.size > 15 * 1024 * 1024) {
      this.setState({ error: 'Photo must be under 15MB.', show_error: true });
      return;
    }

    var reader = new FileReader();
    var self = this;
    reader.onload = function(e) {
      self.setState({ photo_preview: e.target.result });
    };
    reader.readAsDataURL(file);
    this.setState({ photo_file: file, photo_message: '' });
  }

  handleRemovePhoto = () => {
    this.setState({ photo_file: null, photo_preview: null, photo_caption: '', photo_message: '' });
  }

  handleCaptionChange = (event) => {
    this.setState({ photo_caption: event.target.value });
  }

  // submit vote
  handleSubmit(event) {
    event.preventDefault();
    let {
      email,
      date,
      location,
      almond_variety,
      bee_flight,
      bloom_sent,
      bloom_stage,
      verification,
      existing_email
    } = this.state;

    // validate state
    for (var key in formFields) {
      if (this.state[key] == null && formFields[key].required) {
        this.setState({
          error: "Please enter all required fields.",
          show_error: true,
        });
        return;
      }
    }

    // validate email format if provided
    if (email && email.trim() !== '') {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email.trim())) {
        this.setState({
          error: "Please enter a valid email address.",
          show_error: true,
        });
        return;
      }
    }

    // if user has been verfied, double check email has not change
    if (existing_email && email && existing_email !== email) {
      verification = 'failed';
      this.setState({
        verification: "failed"
      });
    }

    fetch('/api/save_bloom', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        email,
        date,
        location,
        almond_variety,
        bee_flight,
        bloom_sent,
        bloom_stage,
        verification
      })
    })
      .then(response => {
        if (!response.ok) {
          this.setState({
            show_error: true,
            error: "An error occured submitting your vote.",
          })
        } else {
          response.json().then(data => {
            let votes = null;
            if (data.votes)
              votes = data.votes;

            if (data.regionId.length) {
              this.props.updateRegion(data.regionId[0].id);
            } else {
              this.props.updateRegion(0);
            }

            // Capture photo data before clearing state
            var photoFile = this.state.photo_file;
            var photoCaption = this.state.photo_caption;

            // Clear form state
            this.setState({
              vote_submitted: true,
              show_error: false,
              date: getToday(),
              almond_variety: null,
              bloom_stage: null,
              votes: null,
              location: null,
              bloom_sent: null,
              bee_flight: null,
              photo_file: null,
              photo_preview: null,
              photo_caption: ''
            });

            // Upload photo in background - this continues even after navigation
            // The upload uses the captured photoFile variable, not component state
            if (photoFile) {
              compressImage(photoFile).then(function(compressed) {
                return uploadPhoto({
                  file: compressed,
                  email: email,
                  bloomVoteId: data.vote_id,
                  zipcode: location,
                  caption: photoCaption
                });
              }).catch(function(err) {
                // Photo upload failed silently - user already navigated away
              });
            }

            // Navigate to map
            if (!email) {
              this.props.handleNext();
            }
            this.props.handleNext(votes);
          })
        }
      });
  }

  render() {
    const { classes } = this.props;

    return (
      // <div className="App">
        <div className="Maincontainer">
          <div className="mob-header-container">
            <a target="_blank" href="https://app.bountiful.ag"><img className="mob-header-logo" src="/images/bountiful-logo-purple.png" alt="bountiful_logo" /></a>
            <a target="_blank" href="https://7462576.fs1.hubspotusercontent-na1.net/hubfs/7462576/Bountiful%20Bloom%20Tracking%20Final.pdf"><img className="mob-header-text" src="/images/bountiful-heading-3x.png" /></a>
            <InfoIcon text="Complete the fields below and click 'Submit' to update the bloom, bee flight, and chill portion data on the map. To save your observations and receive daily bloom status emails, enter your email address." />
          </div>
          <form onSubmit={this.handleSubmit}>

            <div className="mob-input-field-container">
              <input
                className={"mob-input-field" + (this.state.error === "Please enter a valid email address." && this.state.show_error ? " error" : "")}
                id="email"
                value={this.state.email}
                name="email"
                variant="outlined"
                label="Optional"
                placeholder="Email (Optional)"
                onChange={this.handleChange}
              />
            </div>

            { /* DATE */}
            <div className="mob-input-field-container">
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  className={classes.dateTestfield}
                  disableToolbar
                  variant="inline"
                  format="MM/dd/yyyy"
                  margin="normal"
                  name="date"
                  id="date-picker-dialog"
                  inputValue={this.state.inputValue}
                  value={this.state.date}
                  onChange={this.handleDateChange}
                  maxDate={defaultDate}
                  autoOk={true}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                    style: { pointerEvents: "auto" }, // Ensures icon remains clickable
                  }}
                />
              </MuiPickersUtilsProvider>
            </div>


            { /* Location */}
            <div className="mob-input-field-container">
              <Select
                styles={selectCustomStyles}
                isSearchable={true}
                hasError={this.state.error === "Please enter all required fields." && this.state.show_error && this.state.location == null} // Pass error state
                components={{
                  DropdownIndicator: () => null,
                  IndicatorSeparator: () => null,
                }}
                onChange={(e) => this.handleSelectedValue(e, "location")}
                options={this.state.zipcodes}
                value={this.state.zipcodes.filter((option) => option.value === this.state.location)}
                placeholder="Zipcode" />
            </div>

            { /* ALMOND VARIETY */}
            <div className="mob-input-field-container">
              <Select
                styles={selectCustomStyles}
                isSearchable={true}
                hasError={this.state.error === "Please enter all required fields." && this.state.show_error && this.state.almond_variety == null} // Pass error state
                components={{
                  DropdownIndicator: () => null,
                  IndicatorSeparator: () => null,
                }}
                onChange={(e) => this.handleSelectedValue(e, "almond_variety")}
                options={almondVariety}
                value={almondVariety.filter((option) => option.value === this.state.almond_variety)}
                placeholder="Almond Variety" />
            </div>

            { /* BLOOM STAGE */}
            <div className="mob-input-field-container" style={{ position: 'relative' }} >
              <Select
                styles={selectCustomStyles}
                isSearchable={true}
                hasError={this.state.error === "Please enter all required fields." && this.state.show_error && this.state.bloom_stage == null} // Pass error state
                components={{
                  IndicatorSeparator: () => null,
                  DropdownIndicator: () => null,
                }}
                onChange={(e) => this.handleSelectedValue(e, "bloom_stage")}
                options={bloomStage}
                value={bloomStage.filter((option) => option.value === this.state.bloom_stage)}
                placeholder="Bloom Stage" />
              
            </div>

            { /* BLOOM SENT */}
            <div className="mob-input-field-container">
              <Select
                styles={selectCustomStyles}
                isSearchable={true}
                hasError={this.state.error === "Please enter all required fields." && this.state.show_error && this.state.bloom_sent == null} // Pass error state
                components={{
                  IndicatorSeparator: () => null,
                  DropdownIndicator: () => null,
                }}
                onChange={(e) => this.handleSelectedValue(e, "bloom_sent")}
                options={sentiment}
                value={sentiment.filter((option) => option.value === this.state.bloom_sent)}
                placeholder="Bloom Sentiment" />
            </div>

            <div className="mob-input-field-container">
              <Select
                styles={selectCustomStyles}
                isSearchable={true}
                hasError={this.state.error === "Please enter all required fields." && this.state.show_error && this.state.bee_flight == null} // Pass error state
                components={{
                  IndicatorSeparator: () => null,
                  DropdownIndicator: () => null,
                }}
                onChange={(e) => this.handleSelectedValue(e, "bee_flight")}
                options={sentiment}
                value={sentiment.filter((option) => option.value === this.state.bee_flight)}
                placeholder="Bee Activity" />
            </div>

            { /* PHOTO UPLOAD */}
            <div className="mob-input-field-container" style={{flexDirection: 'column', alignItems: 'center'}}>
              <div style={{display: 'flex', alignItems: 'center', gap: '0.75rem', width: '100%', justifyContent: 'center'}}>
                <label style={{
                  display: 'inline-flex', alignItems: 'center', gap: '0.5rem',
                  padding: '0.625rem 1.25rem', border: '1.5px dashed #e8e9ed',
                  borderRadius: '0.5rem', cursor: 'pointer', fontSize: '16px',
                  fontFamily: 'Sofia Pro', color: '#4a4a68', backgroundColor: '#f8f9fc',
                  width: '100%', justifyContent: 'center', boxSizing: 'border-box'
                }}>
                  <span>{this.state.photo_file ? 'Change Photo' : 'Add Photo (Optional)'}</span>
                  <input
                    type="file"
                    accept="image/jpeg,image/png,image/heic,image/heif,image/*"
                    onChange={this.handlePhotoChange}
                    style={{display: 'none'}}
                  />
                </label>
              </div>
              {this.state.photo_preview && (
                <div style={{marginTop: '0.5rem', textAlign: 'center', width: '100%'}}>
                  <img src={this.state.photo_preview} alt="Preview"
                    style={{maxWidth: '100px', maxHeight: '100px', borderRadius: '0.5rem', objectFit: 'cover', border: '1px solid #e8e9ed'}} />
                  <button type="button" onClick={this.handleRemovePhoto}
                    style={{background: 'none', border: 'none', color: '#ef4444', cursor: 'pointer', fontSize: '14px', fontFamily: 'Sofia Pro', marginTop: '0.25rem'}}>
                    Remove Photo
                  </button>
                </div>
              )}
              {this.state.photo_uploading && (
                <div style={{fontSize: '14px', color: '#4b1f7d', marginTop: '0.25rem', textAlign: 'center'}}>Uploading photo...</div>
              )}
              {this.state.photo_message && !this.state.photo_uploading && (
                <div style={{fontSize: '14px', color: this.state.photo_message.includes('failed') || this.state.photo_message.includes('improves') ? '#f59e0b' : '#10b981', marginTop: '0.25rem', textAlign: 'center'}}>{this.state.photo_message}</div>
              )}
            </div>

            {
              this.state.vote_submitted && this.state.email && this.state.verification == 'failed' ? (<div className="success-msg">Success! Check your email to save your vote.</div>) : ""
            }
            {
              this.state.vote_submitted && this.state.email == null ? (<div className="success-msg">Success!</div>) : ""
            }
            {
              this.state.vote_submitted && this.state.email && this.state.verification == 'verified' ? (<div className="success-msg">Success!</div>) : ""
            }
            {
              this.state.show_error ? <div className="error-msg">{this.state.error}</div> : ""
            }
            <button className="mob-btn" type="submit" >Submit</button>
          </form>
        </div>
      // </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(HomeView);
